import { CharField, SwitchField } from "@inmagik/magik-ui"
import { getIn, useFormikContext } from "formik"
import { Col } from "react-bootstrap"
import { RelazioneAtlante } from "../../types"
import { WysiwygField } from "../../components/WysiwygField"

export default function RelazioneAtlanteForm({ col = 8 }: { col?: number }) {
  const { setFieldValue, values, errors, submitCount } = useFormikContext<RelazioneAtlante>()

  return (
    <Col xs={col} className="d-flex flex-column align-items-stretch gap-4">
      <CharField
        label="Nome"
        layout="horizontal"
        value={values.nome}
        onChange={(value) => {
          setFieldValue("nome", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "nome") : undefined}
        errorMessage={getIn(errors, "nome")}
        required
      />
      <SwitchField
        label="Canonica"
        layout="horizontal"
        value={values.canonica}
        onChange={(value) => {
          setFieldValue("canonica", value)
        }}
      />
      <WysiwygField
        label="Descrizione"
        layout="horizontal"
        value={values.descrizione || ""}
        onChange={(value) => {
          setFieldValue("descrizione", value)
        }}
      />
    </Col>
  )
}
